import { Button, Select, Slider, Tooltip } from "antd";
import _ from "lodash";
import React from "react";
import { useDispatch } from "react-redux";
import { updateVegetationEncroachmentFilters } from "redux/actions";
import { VEGETATION_RISK_TYPES } from "./util/DetectionsUtils";

const ZONE_LABELS = {
    ulcs: "Upper Left Cess Strip",
    ulc: "Upper Left Cess",
    u4ft: "Upper 4-Foot",
    urc: "Upper Right Cess",
    urcs: "Upper Right Cess Strip",
    llcs: "Lower Left Cess Strip",
    llc: "Lower Left Cess",
    l4ft: "Lower 4-Foot",
    lrc: "Lower Right Cess",
    lrcs: "Lower Right Cess Strip",
};

const ZONES = [
    ["ulcs", "ulc", "u4ft", "urc", "urcs"],
    ["llcs", "llc", "l4ft", "lrc", "lrcs"],
];

const ZONE_GROUPS = {
    All: _.flatMap(ZONES),
    "Four Foot": ["u4ft", "l4ft"],
    Upper: ["ulcs", "ulc", "u4ft", "urc", "urcs"],
    Lower: ["llcs", "llc", "l4ft", "lrc", "lrcs"],
    Left: ["ulcs", "ulc", "llcs", "llc"],
    Right: ["urcs", "urc", "lrcs", "lrc"],
    Cess: ["ulc", "urc", "llc", "lrc"],
    "Cess Strip": ["ulcs", "urcs", "llcs", "lrcs"],
    None: [],
};

function VegetationEncroachmentFilter({ selectedZones, filters }) {
    const dispatch = useDispatch();

    const toggle = (position) => {
        const next = selectedZones.includes(position) ? selectedZones.filter((v) => v !== position) : [...selectedZones, position];

        dispatch(updateVegetationEncroachmentFilters({ zones: next }));
    };

    return (
        <div className="VegetationEncroachment">
            <h3 className="VegetationEncroachmentTitle">Vegetation Encroachment</h3>
            <div className="VegetationEncroachmentContainer">
                <h4>Percent range</h4>
                <Slider
                    className="VegetationEncroachmentPercentRange"
                    range={true}
                    min={0}
                    max={100}
                    // defaultValue={[0, 100]}
                    defaultValue={filters.percentageRange}
                    marks={{
                        0: `0%`,
                        100: `100%`,
                    }}
                    step={1}
                    onAfterChange={(e) => {
                        dispatch(updateVegetationEncroachmentFilters({ percentageRange: e }));
                    }}
                />
            </div>
            <div className="VegetationEncroachmentContainer">
                <h4>Encroachment Zone</h4>
                <div className="ZoneFilterOptions">
                    {ZONES.map((row, rowIndex) => (
                        <div className="ZoneFilterOptionsRow">
                            {row.map((position) => (
                                <Tooltip
                                    placement={rowIndex === 0 ? "top" : "bottom"}
                                    title={ZONE_LABELS[position]}>
                                    <Button
                                        className="ZoneFilterOptionsButton"
                                        size="small"
                                        key={position}
                                        type={selectedZones.includes(position) ? "primary" : "default"}
                                        onClick={() => toggle(position)}>
                                        {position.toUpperCase()}
                                    </Button>
                                </Tooltip>
                            ))}
                        </div>
                    ))}
                </div>
                <div className="ZoneFilterPresets">
                    <span className="Label">Presets</span>
                    <div className="Shortcuts">
                        {Object.entries(ZONE_GROUPS).map(([group, positions], idx) => (
                            <>
                                {idx > 0 && <span className="group-separator">·</span>}
                                <span
                                    key={group}
                                    className="ShortcutItem"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        dispatch(updateVegetationEncroachmentFilters({ zones: positions }));
                                    }}>
                                    {group}
                                </span>
                            </>
                        ))}
                    </div>
                </div>
            </div>

            <div className="VegetationEncroachmentContainer">
                <h4>Risks</h4>
                <div className="">
                    <Select
                        style={{ width: "100%" }}
                        mode="multiple"
                        placeholder="Risk Types"
                        onChange={(value) => {
                            dispatch(updateVegetationEncroachmentFilters({ riskTypes: value }));
                        }}
                        showArrow
                        maxTagTextLength={28}
                        maxTagCount={3}
                        value={filters.riskTypes}
                        allowClear>
                        {Object.entries(VEGETATION_RISK_TYPES).map(([value, label]) => (
                            <Select.Option
                                key={value}
                                value={value}>
                                {label}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            </div>
        </div>
    );
}

export default VegetationEncroachmentFilter;
